import { cn } from "../lib/utils"

export const Pill = ({ children, className, variant, as = "div" }) => {
  const getVariantClassName = () => {
    if (variant === "vision") return "bg-vision/20 text-vision border-vision border"
    if (variant === "gifts") return "bg-gifts/20 text-gifts border-gifts border"
    if (variant === "brand") return "bg-brand/20 text-brand border-brand border"
    if (variant === "brandSecondary") return "bg-brandSecondary/20 text-brandSecondary border-brandSecondary border"
    if (variant === "circle") return "bg-circle/20 text-circle border-circle border"
    return "bg-brand/20 text-brand border-brand border"
  }
  if (as === "span")
    return (
      <span className={cn("rounded-full px-2 py-1 text-sm", getVariantClassName(), className)}>
        {children}
      </span>
    )
  return (
    <div className={cn("rounded-full px-2 py-1", getVariantClassName(), className)}>{children}</div>
  )
}
